import { render, staticRenderFns } from "./spareItem.vue?vue&type=template&id=1dbc3208"
import script from "./spareItem.vue?vue&type=script&lang=js"
export * from "./spareItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports